import useWindowWidth from "./useWindowWidth"

const useIsMobile = () => {
    const { width } = useWindowWidth()
    return width < 768
}

export default useIsMobile
